module.exports = "<app-game></app-game>\n<!-- <router-outlet></router-outlet> -->\n"